export default __webpack_public_path__ + "static/media/baetter-baking-duesseldorf.fe10b07a.png";